var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75003 14.1668C8.64036 14.1674 8.53164 14.1464 8.43011 14.105C8.32858 14.0635 8.23623 14.0024 8.15836 13.9251C8.08026 13.8477 8.01826 13.7555 7.97595 13.654C7.93365 13.5524 7.91187 13.4435 7.91187 13.3335C7.91187 13.2235 7.93365 13.1145 7.97595 13.013C8.01826 12.9114 8.08026 12.8193 8.15836 12.7418L10.9167 10.0001L8.2667 7.24181C8.11149 7.08568 8.02437 6.87447 8.02437 6.65431C8.02437 6.43416 8.11149 6.22295 8.2667 6.06681C8.34417 5.9887 8.43633 5.92671 8.53788 5.8844C8.63943 5.84209 8.74835 5.82031 8.85836 5.82031C8.96837 5.82031 9.0773 5.84209 9.17884 5.8844C9.28039 5.92671 9.37256 5.9887 9.45003 6.06681L12.6667 9.40014C12.8194 9.55592 12.9049 9.76535 12.9049 9.98348C12.9049 10.2016 12.8194 10.411 12.6667 10.5668L9.33336 13.9001C9.25857 13.9809 9.1685 14.0461 9.06838 14.0918C8.96826 14.1376 8.86006 14.1631 8.75003 14.1668Z",
    fill: "#0071E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBlue);
export default __webpack_public_path__ + "static/media/icon_arrow_blue.bc3169169466002c4df1b757ae1efedf.svg";
export { ForwardRef as ReactComponent };